import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-search\">\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.1953 11.1953C11.4556 10.9349 11.8777 10.9349 12.1381 11.1953L15.1381 14.1953C15.3984 14.4556 15.3984 14.8777 15.1381 15.1381C14.8777 15.3984 14.4556 15.3984 14.1953 15.1381L11.1953 12.1381C10.9349 11.8777 10.9349 11.4556 11.1953 11.1953Z\" />\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.667969 7.33341C0.667969 3.65152 3.65274 0.666748 7.33463 0.666748C11.0165 0.666748 14.0013 3.65152 14.0013 7.33341C14.0013 11.0153 11.0165 14.0001 7.33463 14.0001C3.65274 14.0001 0.667969 11.0153 0.667969 7.33341ZM7.33463 2.00008C4.38912 2.00008 2.0013 4.3879 2.0013 7.33341C2.0013 10.2789 4.38912 12.6667 7.33463 12.6667C10.2802 12.6667 12.668 10.2789 12.668 7.33341C12.668 4.3879 10.2802 2.00008 7.33463 2.00008Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/search.svg
// module id = Bx0U
// module chunks = 36